import { useEffect, useState } from "react";

import { useSelector } from "@jti/store/reduxHooks";
import { selectAccountAgeVerificationStatus } from "@jti/store/selectors/selectAccountAgeVerificationStatus";
import { selectAgeVerificationLimitationStatus } from "@jti/store/selectors/selectAgeVerificationLimitationStatus";

export const useAgeVerification = () => {
  const [isAgeVerificationError, setIsAgeVerificationError] = useState(false);
  const isAgeVerificationRequired = useSelector(selectAgeVerificationLimitationStatus);
  const accountAgeVerificationStatus = useSelector(selectAccountAgeVerificationStatus);

  useEffect(() => {
    if (isAgeVerificationRequired && accountAgeVerificationStatus !== null) {
      setIsAgeVerificationError(!accountAgeVerificationStatus);
    }
  }, [accountAgeVerificationStatus, isAgeVerificationRequired]);

  return { isAgeVerificationError };
};
